jQuery(document).ready(function(){
	/**
	 * Initialize datepicker
	 */
	jQuery('input.datepicker').datepicker({
		dateFormat: 'd.m.yy',
		regional: 'fi'
	});
	
	jQuery("li.gf_readonly input").attr("readonly","readonly");

	// -------------------
	// Back to top button
	// Show button when scrolled enough
	var amountScrolled = 360;

	jQuery(window).scroll(function() {
		// Scroll to top
		if ( jQuery(window).scrollTop() > amountScrolled ) {
			jQuery('a.scrollToTop').fadeIn('').attr('aria-hidden', false);
		} else {
			jQuery('a.scrollToTop').fadeOut('').attr('aria-hidden', true);
		}

	});
	// Animate page movement
	jQuery('a.scrollToTop').click(function() {
		jQuery('html, body').animate({
			scrollTop: 0
		}, 200);
		jQuery('.quick-access > a').first().focus();
		return false;
	});
    
});

jQuery(document).foundation();
